export const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
export const BASE_URL = process.env.REACT_APP_YOUTUBE_BASE_URL;
export const YOUTUBE_VIDEO_API = process.env.REACT_APP_YOUTUBE_VIDEO_API;